import { Link } from 'react-router-dom';
import { RiMenu2Fill } from 'react-icons/ri';
import { FiPlus } from 'react-icons/fi';
import { CiUser } from 'react-icons/ci';
import { useContext, useEffect } from 'react';
import { getRole } from '../../utils/cookies/cookies';
import { ProfileContext } from '../../context/profile';
import { FaRegBell } from "react-icons/fa";
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance';


const Header = (props) => {
  const { profileData, unreadCount, saveUnread } = useContext(ProfileContext);

  const fetchNotifications = async () => {
    try {
      const response = await axiosAuthInstance.get('notification/list',
        { page: 1, limit: 1 }
      );
      if (response && response.status === 200) {
        saveUnread(response?.data?.result?.unreadCount);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const role = getRole();

  return (
    <header className='sticky top-0 z-[999] w-full h-[67px] flex bg-[#FFFFFF] drop-shadow-1 border-b border-light-gray'>
      <div className='h-[67px] flex flex-grow items-center lg:justify-end justify-between shadow-2 py-4 px-4 md:px-6 2xl:px-11'>
        <div className='flex items-center gap-4 lg:hidden'>
          <button
            aria-controls='sidebar'
            onClick={(e) => {
              e.stopPropagation();
              props.setSidebarOpen(!props.sidebarOpen);
            }}
            className='z-[99999] block lg:hidden'
          >
            <RiMenu2Fill className='w-6 h-6' />
          </button>

          <Link className='block flex-shrink-0 lg:hidden' to='/'>
            <h1 className='text-3xl font-medium text-primary'>Wolfy</h1>
          </Link>
        </div>

        <div className='flex items-center gap-2 lg:gap-4'>
          {(role === 'admin' || role === 'HR' || role === 'Social Media Coordinator') &&
            <Link to="/task/add">
              <button className='bg-orange-500 hover:bg-orange-600 text-white p-2 lg:px-4 lg:py-2 rounded-3xl flex items-center'>
                <FiPlus className='h-5 w-5 lg:mr-2' />
                <span className='hidden lg:inline'>New task</span>
              </button>
            </Link>
          }

          <div className='relative'>
            <Link
              to='/notification'
              className='w-10 h-10 flex items-center justify-center bg-orange-100 hover:bg-orange-200 rounded-full'
            >
              <button className='text-gray-600 hover:text-gray-800 p-2'>
                <FaRegBell className='h-5 w-5' />
              </button>
            </Link>

            {unreadCount != 0 &&
              <span className='absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full'>
                {unreadCount}
              </span>
            }
          </div>

          <div className='relative group'>
            <Link
              to='/profile'
              className='flex items-center justify-center w-full h-full text-white'
            >
              {profileData && profileData?.photo ?
                <div className='w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 bg-orange-100 hover:bg-orange-200'>
                  <img
                    src={profileData.photo}
                    alt='Profile'
                    className='w-full h-full rounded-full object-cover'
                  />
                </div>
                :
                <div className='w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 bg-orange-500 hover:bg-orange-600'>
                  <CiUser className='text-xl' />
                </div>
              }
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
